export enum WISHLISTS_SDK_EVENTS {
    WISHLIST_ITEM_CREATED = "wishlistItemCreated",
    WISHLIST_ITEM_DELETED = "wishlistItemDeleted",
    WISHLIST_ITEM_ADDED_TO_CART = "wishlistItemAddedToCart",
}

export enum WISHLISTS_SDK_METHODS {
    OPEN_WISHLISTS_DRAWER = "openWishlistsDrawer",
    CLOSE_WISHLISTS_DRAWER = "closeWishlistsDrawer",
    CREATE_WISHLIST = "createWishlist",
    CREATE_WISHLIST_ITEM = "createWishlistItem",
    DELETE_WISHLIST_ITEM = "deleteWishlistItem",
    GET_WISHLISTS = "getWishlists",
    GET_WISHLIST_ITEMS = "getWishlistItems",
    GET_WISHLISTS_SHARED_STATE_KIT = "getWishlistsSharedStateKit",
}
